import { useCallback, useState } from "react";

import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Combobox, DropdownButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import type { ISearchColumnDropdownProps } from "./types";

const ComboboxWrapper = styled.div`
    width: 200px;
`;

export const SearchColumnDropdown = ({ columns, selectedColumn, onSelect }: ISearchColumnDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleSelect = useCallback(
        (element: { value: string }) => {
            onSelect(element.value);
            setIsOpen(false);
        },
        [onSelect],
    );

    return (
        <ComboboxWrapper>
            <Combobox
                isOpen={isOpen}
                onOpenChange={setIsOpen}
                width={"163px"}
            >
                <Combobox.Trigger>
                    <div>
                        <DropdownButton key="dropdown-button">
                            <Text
                                fontVariant="body2"
                                color={colorsPalettes.carbon[400]}
                            >
                                {columns.find((column) => column.value === selectedColumn)?.name}
                            </Text>
                        </DropdownButton>
                    </div>
                </Combobox.Trigger>
                <Combobox.Content>
                    {columns.map((column) => (
                        <Combobox.Option
                            key={column.value}
                            value={{
                                value: column.value,
                                label: column.name,
                            }}
                            isSelected={column.value === selectedColumn}
                            onClick={() => handleSelect(column)}
                        >
                            <Combobox.OptionLabel>{column.name}</Combobox.OptionLabel>
                        </Combobox.Option>
                    ))}
                </Combobox.Content>
            </Combobox>
        </ComboboxWrapper>
    );
};
